import { Component, Input, OnInit } from '@angular/core';

const cssMap = {
  VALIDO: 'valid',
  'IN SCADENZA': 'expiring',
  SCADUTO: 'expired',
  'Non disponibile': ''
};

@Component({
  selector: 'app-status-badge',
  templateUrl: './status-badge.component.html',
  styleUrl: './status-badge.component.scss'
})
export class StatusBadgeComponent implements OnInit {
  @Input() status: 'VALIDO' | 'IN SCADENZA' | 'SCADUTO' | 'Non disponibile' = 'VALIDO';
  cssClass = '';

  ngOnInit() {
    this.cssClass = cssMap[this.status];
  }
}
